/**
 * @generated SignedSource<<fc7522e75738b12f45a453caeff0f3e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeactivateJiraCloudInput = {
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deactivateJiraCloudMutation$variables = {
  input: DeactivateJiraCloudInput;
};
export type deactivateJiraCloudMutation$data = {
  readonly deactivateJiraCloud: {
    readonly viewer: {
      readonly company: {
        readonly jiraVerificationKey: string | null;
        readonly jiraInstallationLinked: boolean | null;
      } | null;
    } | null;
  } | null;
};
export type deactivateJiraCloudMutation = {
  variables: deactivateJiraCloudMutation$variables;
  response: deactivateJiraCloudMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraVerificationKey",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jiraInstallationLinked",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deactivateJiraCloudMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateJiraCloudPayload",
        "kind": "LinkedField",
        "name": "deactivateJiraCloud",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deactivateJiraCloudMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateJiraCloudPayload",
        "kind": "LinkedField",
        "name": "deactivateJiraCloud",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "44c9ee98241c824846e4ce45cb41ccc8",
    "id": null,
    "metadata": {},
    "name": "deactivateJiraCloudMutation",
    "operationKind": "mutation",
    "text": "mutation deactivateJiraCloudMutation(\n  $input: DeactivateJiraCloudInput!\n) {\n  deactivateJiraCloud(input: $input) {\n    viewer {\n      company {\n        jiraVerificationKey\n        jiraInstallationLinked\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1424fe6457af4688979ada331271949a";

export default node;
